import { gql } from 'apollo-angular-boost';
import { DeepRequired } from 'utility-types';
import { IAccount } from '../../../../interfaces/graph-types';

export type CandidateAttributesQueryVariables = {
  accountId: IAccount['id'];
};

export type CandidateAttributesQuery = DeepRequired<{
  account: IAccount;
}>;

export const candidateAttributesQuery = () => gql`
  query AccountCandidatesAttributesCandidateAttributes($accountId: ID!) {
    account(accountId: $accountId) {
      id
      candidateAttributes {
        id
        name
        value
      }
    }
  }
`;
